import {
    createPromotionalCard,
    IPromotionalCardProperties,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import { HtmlId } from 'app/enums/elementId';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

export const mountPromotionalCard = (wrapperId: HtmlId) =>
    createComponentById(createPromotionalCard, wrapperId, NO_PATTERN_BUSINESS_LOGIC);

export const updatePromotionalCard = (
    comp: PromotionalCard | null,
    props: Partial<IPromotionalCardProperties>) => {
    return comp?.update(props);
};
